<template>
  <div class="reaction-icon">
    <v-menu
      content-class="hide-scrollbar"
      class="hide-scrollbar"
      :z-index="10"
      :max-height="200"
      open-on-hover
      offset-y
      bottom
      close-delay="100"
    >
      <template v-slot:activator="{ on, attrs }">
        <div @click="handleIconClick" class="d-inline" v-on="on" v-bind="attrs">
          <v-icon :size="size * 0.8" color="textColor"> {{ icon }}</v-icon>
          <span class="pl-1" :style="listItemStyles"> {{ count }} </span>
        </div>
      </template>
      <v-card style="padding: 8px" v-if="tooltip">
        {{ tooltip }}
      </v-card>
      <v-card v-else>
        <v-list>
          <v-list-item
            :style="{ fontWeight: fontWeightBold }"
            v-for="member in memberList"
            :key="member.id"
          >
            <v-list-item-avatar color="primary">
              <v-img :alt="member.name" :src="member.avatar_url">
                <template v-slot:placeholder>
                  <AvatarPlaceholder avatarType="GroupMember" />
                </template>
              </v-img>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title>{{ member.name }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-card>
    </v-menu>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue"
import THEME from "constants/theme"
import { MemberReaction } from "components/ReactionCount/reaction-count.types"
import AvatarPlaceholder from "components/UI/AvatarPlaceholder.vue"
import { useIsBreakpointInNames } from "features/common/vuetify/useVuetify"

const { fontFamily, fontWeightRegular, fontWeightBold } = THEME.typography

export default defineComponent({
  name: "ReactionIcon",
  components: {
    AvatarPlaceholder,
  },
  props: {
    count: { type: Number, default: 0 },
    icon: { type: String, default: "" },
    size: { type: Number, default: 0 },
    memberList: { type: Array as () => MemberReaction[], default: () => [] },
    tooltip: { type: String, default: undefined },
  },
  computed: {
    listItemStyles(): object {
      return {
        fontFamily,
        fontSize: "0.8rem",
        fontWeight: fontWeightRegular,
        color: this.$vuetify.theme.themes.light.textColor,
        margin: 0,
      }
    },
  },
  setup(props, { emit }) {
    const isMobile = useIsBreakpointInNames(["xs", "sm"])
    const handleIconClick = () => {
      if (!isMobile.value) {
        emit("click")
      }
    }

    return {
      fontWeightBold,
      handleIconClick,
    }
  },
})
</script>

<style scoped>
.reaction-icon {
  cursor: pointer;
}
</style>
